export const oExercises = [
    {
        id: "1",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Халдьаайы тыа маһын курдук\nХамаандата суох,\nКуула тыа ойуурун курдук\n......... суох.",
        answer: "Оруолдьута",
        line: 861
    },
    {
        id: "2",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Тэллэххэ сытар\nТэҥнээх кэргэнэ,\nХоойҥо сытар\nХолоонноох .........",
        answer: "доҕоро",
        line: 876
    },
    {
        id: "3",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Тоҕус уон субан туруйа курдук уолаттар,\nСэттэ уон тыһы ......... курдук кыргыттар.",
        answer: "кыталык",
        line: 881
    },
    {
        id: "4",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Кыланар бөҕө кылааттаах,\nМаҥырыыр бөҕө манньыаттаах,\nҮөгүлүүр бөҕө .........",
        answer: "үптээх",
        line: 900
    },
    {
        id: "5",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Эһэ кыылы иэдэһиттэн илибирэччи тутта,\nТаба кыылы таныытыттан ......... тутта.",
        answer: "талыбыраччы",
        line: 941
    },
    {
        id: "6",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Ириэнэх сири иэччэҕин хараҕар дылы\nИбили түһэн кэбистэ,\nТоҥмут сири тобугун хараҕар дылы\n......... түһэн кэбистэ.",
        answer: "Тобулу",
        line: 1025
    },
    {
        id: "7",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Нөҥүө улуус нөрүөннээҕэ,\nАтын улуус .........",
        answer: "ааттааҕа",
        line: 1056
    },
    {
        id: "8",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Кимтэн кииннээххиний,\nХантан .........,\nТуохтан тутаахтааххыный?",
        answer: "хааннааххыный",
        line: 1076
    },
    {
        id: "9",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Туспа улуус туһааннааҕа убайыам,\nНөҥүө улуус нөрүөннээҕэ доҕоруом,\nАтын дойду ......... атаһыам.",
        answer: "ааттааҕа",
        line: 1137
    },
    {
        id: "10",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Биэрдэргин да ылар киһи кэллим,\n......... да ылар киһи кэллим.",
        answer: "Биэрбэтэргин",
        line: 1394
    },
    {
        id: "11",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Сыыр сиҥнибитин курдук\nСылластыгас сымыһахтаах,\nБыраан быстыбытын курдук\n......... уостаах,\nХайа хайдыбытын курдук\nХанньастыгас айахтаах.",
        answer: "Былластыгас",
        line: 1429
    },
    {
        id: "12",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Сытамматах сырайдаах,\n......... таһаалаах,\nТупсубатах ньуурдаах.",
        answer: "Табыллыбатах",
        line: 1457
    },
    {
        id: "13",
        exercise: "1. Олоҥхо олук хоһоонноругар көппүт тыллары ситэрэн биэр",
        translate: "напишите пропущенные слова в эпических формулах олонхо",
        question: "Аҕыс илии амынахтаах сырайдаах,\nТоҕус илии көлбөхтөөх .........",
        answer: "ньуурдаах",
        line: 1455
    },
    {
        id: "14",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Саамал кымыһынан санаатын тарҕатта,\nКөҕүөр кымыһынан көхсүн .........",
        answer: "көнньүөртэ",
        line: 905
    },
    {
        id: "15",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Өрөөбүт уоһун өһүллэ,\n......... уоһун хоҥнордо.",
        answer: "Хоммут",
        line: 1049
    },
    {
        id: "16",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Барар сирим баҕана үүтэ буолла,\nКэлэр сирим ......... үүтэ буолла. ",
        answer: "кэлии",
        line: 1103
    },
    {
        id: "17",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Ытык тылбын ыкка сиэтимэ,\nДьоһун тылбын ......... тоҥсуттарыма.",
        answer: "суорга",
        line: 1140
    },
    {
        id: "18",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Көмүскүүрүм ......... уута буолла,\nХарыһыйарым хараҕым уута буолла.",
        answer: "көмүскэм",
        line: 1165
    },
    {
        id: "19",
        exercise: "2. Сомоҕо домохтор көппүт тылларын ситэрэн биэр",
        translate: "напишите пропущенные слова в фразеологизмах",
        question: "Хойут утуйар дьон\nХоһоон оҥосто сылдьыахтара,\nЭрдэ турар дьон\n......... гына сылдьыахтара.",
        answer: "Элэк",
        line: 1199
    },
    {
        id: "20",
        exercise: "3. Өс хоһоонун ситэр",
        translate: "дополните пословицы",
        question: "Үгүс тыл сымсах,\nАҕыйах тыл .........",
        answer: "минньигэс",
        line: 1396
    },
    {
        id: "21",
        exercise: "3. Өс хоһоонун ситэр",
        translate: "дополните пословицы",
        question: "......... киһи тыла биир,\nҮчүгэй ат кымньыыта соҕотох.",
        answer: "Үтүө",
        line: 1398
    },
]